import { NgModule } from '@angular/core';
import { IonicModule } from 'ionic-angular';

import { AssinaturaEletronicaComponent } from './assinatura-eletronica/assinatura-eletronica-component';
import { AssinaturaService } from './assinatura-service';

@NgModule({
  declarations: [
    AssinaturaEletronicaComponent
  ],
  imports: [
    IonicModule
  ],
  exports: [
    AssinaturaEletronicaComponent
  ],
  providers: [
    AssinaturaService
  ]
})
export class AssinaturaModule { }


// WEBPACK FOOTER //
// ./src/assinatura/assinatura.module.ts